import { NewsItems, SuccessSteps } from "@prmf/site-components";
import { Post } from "@prmf/site-data";
import { routes, t } from "@prmf/site-router";
import { useLoaderData } from "@remix-run/react";

const Careers: React.FC = () => {
  const data = useLoaderData<{ posts: Post[] }>();
  return (
    <div>
      <div className="grid aspect-square max-h-[20vh] w-full items-center bg-[#1FB7D3] text-white">
        <h2 className="container text-4xl font-light">
          {t(routes.careers, "title")}
        </h2>
      </div>
      <div className="container grid items-center gap-20 py-10 font-light md:grid-cols-2">
        <div>
          <p>
            We value dedication, creativity, craftsmanship and innovation.
            Working as one big family, whether from our head office in Lancing,
            or elsewhere around the UK, our team are essential to our success.
          </p>
        </div>
        <div>
          <blockquote className="flex flex-col gap-2">
            <div className="relative rounded-lg bg-gray-100 p-8">
              <p>
                I have had the chance to learn a great deal in my position and
                to take that knowledge further. The team I am in is small, but
                has a crucial role within the company and I feel this in my day
                to day work which makes it a more enjoyable experience.
              </p>

              <svg
                className="absolute -bottom-3 right-10 h-3 w-4 -scale-100 fill-gray-100"
                viewBox="0 0 100 70"
              >
                <path d="m50 0 50 70H0z" />
              </svg>
            </div>
            <cite className="ml-auto mr-16 p-2 text-xs not-italic">
              Comments from the PaulaRosa Manhattan team
            </cite>
          </blockquote>
        </div>
      </div>
      <div>
        <div className="border-b-8 border-gray-100">
          <h3 className="container mb-2 text-lg font-bold uppercase">
            Current job opportunities
          </h3>
        </div>
        <NewsItems className="container mb-40 mt-10" posts={data?.posts} />
      </div>
      <SuccessSteps />
    </div>
  );
};

export default Careers;
